import { render, staticRenderFns } from "./RequiredProperties.vue?vue&type=template&id=21fe064e&scoped=true&"
import script from "./RequiredProperties.vue?vue&type=script&lang=js&"
export * from "./RequiredProperties.vue?vue&type=script&lang=js&"
import style0 from "./RequiredProperties.vue?vue&type=style&index=0&id=21fe064e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe064e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChip,VChipGroup})
